import { PaymentProvider } from '@finxone-platform/shared/sys-config-types';

export function getProviderSpecificPageLimitForSavingsAccounts(
  provider: PaymentProvider | undefined,
): number {
  if (!provider) return 50;
  return provider === PaymentProvider.SAASCADA ? 5 : 50;
}
